import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from 'core/route.protected';
import Loading from 'components/_common/Loading';
import ProductList from './Product.list';
import ProductUpdate from './Product.update';

function Product() {
    return (
        <>
            <Routes>
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <React.Suspense fallback={<Loading />}>
                                <ProductList />
                            </React.Suspense>
                        </ProtectedRoute>
                    }
                ></Route>

                <Route
                    path="/add"
                    element={
                        <ProtectedRoute>
                            <React.Suspense fallback={<Loading />}>
                                <ProductUpdate />
                            </React.Suspense>
                        </ProtectedRoute>
                    }
                ></Route>

                <Route
                    path="/update/:id"
                    element={
                        <ProtectedRoute>
                            <React.Suspense fallback={<Loading />}>
                                <ProductUpdate />
                            </React.Suspense>
                        </ProtectedRoute>
                    }
                ></Route>
            </Routes>
        </>
    );
}

export default Product;